module.exports = __webpack_public_path__ + "static/media/bannerCase.1dac6835.png";